import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Callout from "./Callout";
import SubScribeCards from ".";
import useOnScreen from "@/src/utils/hooks";
import { sendAnalyticsEvent } from "@/src/utils/analytics";
import { AuthContext } from "@/pages/_app";

const SubScribeCardsContainer = () => {
  const ref = useRef(null);
  const isOnScreen = useOnScreen(ref);
  const [wasVisible, setWasVisible] = useState(false);
  const { authContext } = useContext(AuthContext);
  const subs = authContext?.subs ?? [];
  useEffect(() => {
    if (!wasVisible) {
      sendAnalyticsEvent({ type: "paywall_visible", value: "" });
      setWasVisible(true);
    }
  }, [isOnScreen, wasVisible]);

  return (
    <div className={"subscribeCardsContainer bg-slate-100	"} ref={ref}>
      <div className="subscribe-cards-shadow w-full "></div>
      <Callout />
      <div>
        <SubScribeCards activeSubscriptionProductIds={subs ?? []} />
      </div>
    </div>
  );
};

export default SubScribeCardsContainer;
